import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import VonalkodTesztlapEditService from 'app/admin/vonalkodtesztlap/service/VonalkodTesztlapEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import ExamImageField from 'app/admin/examImage/ExamImageField';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'vonalkodTesztlapEditForm',
	text: 'Vonalkod Tesztlap',
	textKey: 'vonalkodtesztlap',
	service: VonalkodTesztlapEditService,
	icon: 'person',
	fields: [
		{
			key: `vonalkod`,
			component: EditFormGroupFields,
			className: 'w-full flex flex-col sm:flex-row',
			fields: [
				{
					key: 'vonalkodVizsga',
					text: 'Vizsga vonalkód',
					textKey: 'vonalkodVizsga',
					component: EditFormTextField,
					type: 'number',
					required: true,
					className: 'sm:mr-6'
				},
				{
					key: 'vonalkodVizsgazo',
					text: 'Vizsgazó vonalkód',
					textKey: 'vonalkodVizsgazo',
					component: EditFormTextField,
					type: 'number',
					required: true,
					className: 'sm:mr-6'
				}
			]
		},
		{
			key: 'elokeszitettPath',
			text: 'Előkészített',
			textKey: 'elokeszitettPath',
			component: ExamImageField,
			imageUrl: `${nBossConnection.baseUrl}fmBrowserTableControl/getFileByPath?path=`,
			readOnly: true
		}
	]
};

function VonalkodTesztlapEditForm() {
	return <EditFormPage config={config} />;
}

export default VonalkodTesztlapEditForm;
